import { useState } from 'react';
import { Dropdown } from 'components/helpers/Dropdown';

import './AssestmentLanguageSelector.scss';

export type LanguageOption = {
    value: string;
    label: string;
}
export type LanguageOptions = LanguageOption[]

type AssessmentLanguageSelectorProps = {
    languageOptions: LanguageOptions;
    selectedLanguageControlled?: LanguageOption;
    onSelectLanguage?: (language: LanguageOption) => void;
    disabled?: boolean;
};

const AssessmentLanguageSelector = ({ onSelectLanguage, languageOptions, selectedLanguageControlled, disabled }: AssessmentLanguageSelectorProps) => {
    const [selectedLanguage, setSelectedLanguage] = useState<LanguageOption | undefined>(selectedLanguageControlled);

    const handleLanguageChange = (value: LanguageOption) => {
        setSelectedLanguage(value);

        onSelectLanguage?.(value);
    };

    return (
        <Dropdown
            placeholder='Select language'
            options={languageOptions}
            // value={selectedLanguageControlled || selectedLanguage}
            value={selectedLanguage}
            onChange={handleLanguageChange}
            showTooltip
            readOnly={disabled}
            tooltipText='Select the language you would like to take the assessment in'
            dropdownProps={{
                id: 'assessment-language-selector',
                isSearchable: false,
            }}
        />
    );
};

export default AssessmentLanguageSelector;